import { Grid } from '@wegroup/design-system';
import cogoToast from 'cogo-toast';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Enterprise } from '../../../../../../../types/ProductFactory';
import { formatAddress } from '../../../../../../common/src/utils/commonUtils';
import { useFlowsSelector } from '../../../../../../common/src/utils/globalVariables';
import QuestionGroupActions from '../../../ui/advisory-flow/components/question-group-components/QuestionGroupActions';
import LabelValue from '../../../../../../sales-conversation/src/components/offers/LabelValue';
import YesNoQuestion from '../../../ui/advisory-flow/components/shared-components/YesNoQuestion';
import AdvisoryFlowMainContainer from '../../../ui/advisory-flow/components/app-shell/AdvisoryFlowMainContainer';
import QuestionGroupAssistantQuestion from '../../../ui/advisory-flow/components/question-group-components/QuestionGroupAssistantQuestion';
import QuestionGroupBody from '../../../ui/advisory-flow/components/question-group-components/QuestionGroupBody';

interface Props {
  isMobile?: boolean;
  company: Enterprise;
  previousSubView: () => void;
  nextSubView: (arg0: string) => void;
  nextQuestionHandler: () => void;
}

const CbeConfirmation: React.FC<React.PropsWithChildren<Props>> = ({
  isMobile,
  company,
  previousSubView,
  nextSubView,
  nextQuestionHandler,
}) => {
  const { t } = useTranslation();

  const validationErrorMessage = useFlowsSelector(
    (state) => state.flows.formState.validationErrorMessage,
  );

  useEffect(() => {
    if (validationErrorMessage) {
      cogoToast.info(
        t('Oops there is some incorrect data Please adjust the information'),
        { hideAfter: 7 },
      );
      nextSubView('cbeData');
    }
  }, [validationErrorMessage]);

  const Question = () => (
    <QuestionGroupAssistantQuestion
      question={t('Is this info about your company correct?')}
      description={t('If not, you can edit the details that are incorrect')}
    />
  );

  return (
    <AdvisoryFlowMainContainer data-test-id="ProdFac_AddressToInsure">
      <Question />
      <QuestionGroupBody>
        <Grid
          margin="auto"
          maxW="3xl"
          templateColumns={{ base: 'repeat(2, 1fr)', laptop: 'repeat(3, 1fr)' }}
          gap="12"
          pb="12"
          alignSelf="center"
        >
          <LabelValue label={t('Company name')}>{company.name}</LabelValue>
          <LabelValue label={t('CBE number')}>
            {company.company_registration?.nr || company.cbe}
          </LabelValue>
          <LabelValue label={t('Company address')}>
            {formatAddress(company.address || {})}
          </LabelValue>
        </Grid>
        {!isMobile && (
          <YesNoQuestion
            handleYes={nextQuestionHandler}
            handleNo={() => nextSubView('cbeData')}
          />
        )}
      </QuestionGroupBody>
      <QuestionGroupActions onBack={previousSubView} hideContinueButton>
        {isMobile && (
          <YesNoQuestion
            handleYes={nextQuestionHandler}
            handleNo={() => nextSubView('cbeData')}
          />
        )}
      </QuestionGroupActions>
    </AdvisoryFlowMainContainer>
  );
};

export default CbeConfirmation;
